export default {
  common: {
    logout: "Log Out",
    login: "Log In",
    signup: "Create Account",
    downloadFailed: "Download Failed",
    requestFailed: "Request Failed",
    processing: "Processing",
    language: "Language",
    expand: "Expand",
    collapse: "Collapse",
    buyNow: "Select Plan",
    improve: "Improve",
    upgrade: "Upgrade Plan",
    search: "Search",
    newProject: "New Project",
    view: "View",
    open: "Open",
    confirm: "Confirm",
    cancel: "Cancel",
    close: "Close",
    noMore: "No More Data",
    performTasks: "Active Tasks:",
    account: "Account",
    demo: "Demo",
    contact: "Contact Us",
    userManage: "User Management",
    // Test Panel
    test: {
      title: "Test",
      expand: "Expand",
      collapse: "Collapse",
      loginStatus: "Login Status",
      subscriptionStatus: "Subscription",
      currentUser: "Current User",
      currentRole: "Current Role",
      isAdmin: "Admin",
      adminPrivileges: "Admin Privileges",
      userType: "User Type",
      shortcuts: "Shortcuts",
      loggedIn: "Logged In",
      notLoggedIn: "Not Logged In",
      subscribed: "Subscribed",
      notSubscribed: "Not Subscribed",
      yes: "Yes",
      no: "No",
      enabled: "Enabled",
      disabled: "Disabled",
      visitor: "Visitor",
      trial: "Trial",
      paid: "Paid",
      orgAdmin: "Org Admin",
      toggleSub: "Toggle Subscription",
      toggleAdmin: "Toggle Admin",
      refresh: "Refresh"
    },
    // API Error Codes
    errorCodes: {
      server_error: "Server Error",
      param_empty: "Parameters cannot be empty",
      unauthorized: "Unauthorized Error",
      user_not_registered: "User is not registered",
      user_exists: "User already exists",
      user_disabled: "User has been disabled",
      forbidden: "Operation Prohibited",
      user_quota_insufficient: "Insufficient user quota",
      data_not_found: "Data not found",
      data_exists: "Data already exists",
      name_exists: "Name already exists",
      project_id_empty: "Project ID cannot be empty",
      project_not_found: "The project does not exist",
      task_type_empty: "Task type cannot be empty",
      project_file_name_empty: "Project file name cannot be empty",
      insufficient_space: "Insufficient space",
      task_id_empty: "Task ID cannot be empty",
      task_not_found: "The task does not exist",
      task_name_empty: "Task name cannot be empty",
      task_template_not_found: "The task template does not exist",
      task_processing: "The task is in progress",
      status_empty: "Status cannot be empty",
      size_empty: "Size cannot be empty",
      algorithm_id_empty: "Algorithm ID cannot be empty",
      input_param_empty: "Input parameters cannot be empty",
      project_data_empty: "Project data cannot be empty",
      file_upload_failed: "Failed to upload file",
      file_size_empty: "File size cannot be empty",
      user_has_org: "User already belongs to an organization",
      billing_cycle_not_found: "Billing cycle does not exist",
      parent_node_id_empty: "Parent node ID cannot be empty",
      share_not_found: "The shared content no longer exists.",
      share_expired: "The shared content has expired.",
      share_requires_password: "The shared content requires a password.",
      share_password_incorrect: "Incorrect share password",
      user_not_found: "User not found",
      username_exists: "Username already exists",
      login_failed: "Login failed",
      email_exists: "Email already exists",
      reg_email_sent: "Registration email sent",
      password_incorrect: "Incorrect password",
    }
  },
  layout: {
    title: "Cloud Computing Portal",
  },
  pages: {
    dashboard: "Dashboard",
    projects: "Projects",
    pipelines: "Pipelines",
    tasks: "Tasks",
  },
  home: {
    hero: {
      titleAccent: "SLAM Cloud Computing + AEC",
      titleMain: "Solution",
      subtitle:
        "We offer you the handheld LiGrip, providing a complete AEC workflow from data acquisition and processing to 3D visualization.",
    },
    workflow: {
      kicker: "Integrated Workflow",
      title: "Integrated AEC Data Collaboration Platform",
      description:
        "From the field to the cloud, from collaboration to decision-making — make data flow intelligently and team collaboration more efficient.",
      videoAlt: "Integrated workflow demo video",
      playAlt: "Play Video",
      pauseAlt: "Pause Video",
      cards: {
        integration: {
          title: "Integrated Workflow",
          description:
            "Mobile App + Cloud Computing + AEC Data Analysis + Sharing, seamlessly integrated. From on-site data collection and cloud-based computation to professional analysis and collaborative sharing, we eliminate data silos end-to-end, establishing a complete decision-making chain.",
        },
        minimalist: {
          title: "Minimalist Operation",
          description:
            "One-click upload, automatic computation. No complex training required. By uploading raw data through LiShare, the backend automatically processes it, allowing your team to focus on core business rather than software operations.",
        },
        collaboration: {
          title: "Team Collaboration",
          description:
            "Support for multi-user real-time online collaboration and annotation. Comment and assign tasks on models and drawings simultaneously, with real-time feedback synchronization, greatly enhancing cross-disciplinary and cross-regional collaboration efficiency.",
        },
        analysis: {
          title: "Data Analysis & Reporting",
          description:
            "Built-in powerful marking and measurement tools for various AEC scenarios. Generate standardized data reports (PDF/Excel) with one click, providing strong support for project reporting and decision-making.",
        },
        deployment: {
          title: "On-Premises Deployment",
          description:
            "Support for enterprise deployment on your own servers, with full data autonomy and control. Meets high security levels and industry compliance requirements, ensuring that core assets and project data remain secure.",
        },
        security: {
          title: "Data Security & Privacy",
          description:
            "LiShare has obtained ISO 27001 + ISO 27701 dual certification. We ensure data and privacy security from technology, process, and management perspectives, providing comprehensive protection for your business.",
        },
      },
    },
    pricing: {
      title: "Pricing",
      currency: "CHF",
      period: "/month",
      billing: {
        monthly: "Billed monthly,",
        yearly: "Billed annually,",
        threeYears: "Billed every 3 years,",
      },
      taxText: "excl. taxes",
      popular: "Most Popular",
      tabs: {
        monthly: "Monthly",
        yearly: "Yearly",
        yearlyBadge: "Save 17%",
        threeYears: "3 Years",
        threeYearsBadge: "Save 44%",
      },
      cta: {
        select: "SELECT PLAN",
        contact: "CONTACT SALES",
      },
      plans: {
        starter: {
          name: "Starter",
          summary: "Easy sharing, storage, and processing. Best plan for individuals.",
          features: [
            "500 FREE credits included yearly",
            "FREE self-paced training",
          ],
        },
        pro: {
          name: "Pro",
          summary:
            "Project tracking, advanced processing options, and easy sharing. Ideal for professional small and medium teams.",
          features: [
            "2,500 FREE credits included yearly",
            "FREE self-paced training",
          ],
        },
        team: {
          name: "Team",
          summary:
            "Built for collaborative teams that need shared workspaces, role control, and more processing capacity.",
          features: [
            "1,200 FREE credits included yearly",
            "Shared team workspace",
          ],
        },
        business: {
          name: "Business",
          summary:
            "Designed for multi-project business teams with higher quotas and more flexible collaboration workflows.",
          features: [
            "5,000 FREE credits included yearly",
            "Priority processing and project management",
          ],
        },
        enterprise: {
          name: "Enterprise",
          summary:
            "Advanced team access functionalities and seamless integration with third parties. Ideal for large and enterprise teams needing robust scalability.",
          customLabel: "Custom Price",
          customPrice: "Contact Us",
        },
      },
    },
    footer: {
      brand: "Cloud-SLAM",
      description:
        "As a provider of integrated SLAM + cloud computing solutions, we are committed to combining advanced spatial perception technology with cloud computing to offer customers efficient and convenient 3D digital tools.",
      contactTitle: "Contact Us:",
      address: "729 Heinz Avenue, Suite 9, Berkeley, California 94710, USA",
      phone: "400-009-9312",
      email: "contact@cloud-slam.com",
      time: "Monday to Friday, 9:00–18:00",
    },
  },
  paymentSuccess: {
    iconAlt: "Payment Successful",
    title: "Your order has been successfully paid",
    orderNumber: "Order Number:",
    orderTime: "Order Time:",
    orderAmount: "Order Amount:",
    billingCycle: "Billing Cycle:",
    amountPrefix: "USD $",
    action: "View Order & Generate Invoice",
    placeholder: "XXXXXXXXXXXXXXXXX",
    intervalUnit: {
      DAY: "Daily",
      MONTH: "Monthly",
      YEAR: "Yearly",
    },
  },
  paymentFailed: {
    iconAlt: "Payment Failed",
    title: "Your payment has been suspended",
    orderNumber: "Order Number:",
    orderTime: "Order Time:",
    backToStore: "Back to Home",
    continueToPay: "Continue to Pay with PayPal",
    amountPrefix: "USD $",
    amountPlaceholder: "USD $",
    placeholder: "XXXXXXXXXXXXXXXXX",
  },
  projectManage: {
    deleteTitle: "Confirm Deletion",
    deletePrompt: "Are you sure you want to delete all data from project {name}?",
    renameTitle: "Rename Project",
    projectNameLabel: "Project Name",
    projectNamePlaceholder: "Enter project name",
    newTitle: "New Project",
    newPlaceholder: "Enter project name",
    loading: "Loading...",
    noData: "No Data",
    noMoreData: "No More Data",
    // Messages
    loadListFailed: "Failed to load project list",
    pleaseEnterName: "Please enter a project name",
    nameLengthInvalid: "Project name must be 2–20 characters",
    createSuccess: "Project created successfully",
    deleteSuccess: "Project deleted successfully",
    renameSuccess: "Project renamed successfully"
  },
  engineeringManage: {
    pageTitle: "Project Management",
    backHome: "Back to Previous Page",
    uploadData: "Upload Data",
    projectIdLabel: "Project ID",
    defaultProjectTitle: "Software New City Survey and Mapping",
    tableName: "Name",
    tableCreationTime: "Created At",
    tableAlgorithm: "Type",
    tableSize: "Size",
    tableState: "Status",
    tableOperation: "Operation",
    statusFilterPlaceholder: "Filter by status",
    statusAll: "All Statuses",
    statusOptions: {
      failed: "Failed",
      running: "Running",
      success: "Success",
      init: "Initializing",
      uploading: "Uploading",
      upload_success: "Upload Successful",
      wait_process: "Queued",
      upload_fail: "Upload Failed",
    },
    noData: "No Data",
    previous: "Previous",
    next: "Next",
    operationPending: "Currently Unavailable",
    uploadPending: "Currently Unavailable",
    actionLog: "Log",
    actionFeedback: "Feedback",
    actionExport: "Report Preview",
    actionContact: "Contact Us",
    actionDownload: "Download",
    actionDelete: "Delete",
    stateInit: "Initializing",
    stateUploading: "Uploading",
    stateFailed: "Failed",
    stateUploadSuccess: "Upload Successful",
    stateWaitProcess: "Queued",
    stateUploadFail: "Upload Failed",
    stateRunning: "Running",
    stateSuccess: "Success",
    deleteTitle: "Confirm Deletion",
    deletePrompt: "Are you sure you want to delete task {name}?",
    deleteConfirm: "Are you sure you want to delete task \"{name}\"?",
    deleteSuccess: "Task deleted successfully",
    deleteFailed: "Failed to delete task",
    feedbackSuccess: "Feedback submitted successfully",
    downloadSuccess: "Download started",
    noExportTypes: "No export types available",
    loadExportTypesFailed: "Failed to load export types",
    downloadFailed: "Download failed",
    exportDataTitle: "Export Data",
    exportDataCancel: "Cancel",
    exportDataConfirm: "Confirm",
    exportDataOriginal: "Original Data",
    fileFormatLiData: "Point Cloud Data",
    fileFormatGeojson: "Trajectory Data",
    fileFormatPdf: "Report"
  },
  demo: {
    title: "Demo",
    cardTitle: "Ancient Tree Survey Project",
    cardDate: "February 10, 2026",
  },
  taskPanel: {
    projectName: "Ancient Tree Survey Project",
    projectDate: "February 10, 2026",
    eta: "Estimated {time}",
    processing: "Processing",
    waiting: "Waiting",
    error: "Error",
    statusFailed: "Failed",
    statusRunning: "Running",
    statusSuccess: "Success",
    statusInit: "Initializing",
    statusUploading: "Uploading",
    statusUploadSuccess: "Upload Successful",
    statusWaitProcess: "Queued",
    statusUploadFail: "Upload Failed",
    moveUp: "Move Up",
    moveDown: "Move Down",
    view: "View",
    delete: "Delete",
    taskIconAlt: "Task",
  },
  message: {
    loginLiShare: "Log In",
    loginAccount: "Account",
    loginAccountPlaceholder: "Enter your email or username",
    loginPassword: "Password",
    loginPasswordPlaceholder: "Enter your password",
    loginRememberMe: "Remember Me",
    loginForgotPassword: "Forgot Password?",
    loginNewUser: "New User?",
    loginButton: "Log In",
    rememberMe: "Remember Me",
    loginPhone: "Phone Login",
    phone: "Phone",
    loginPhonePlaceholder: "Enter your phone number",
    loginPhoneFormatPlaceholder: "Enter a valid phone number",
    loginCodePlaceholder: "Enter verification code",
    loginSuccess: "Login successful",
    loginFailed:
      "Login failed. Please check your phone number and verification code.",
    loginRegisterSameAgreeTerms:
      "Please agree to the User Agreement and Privacy Policy",
    loginCode: "Verification Code",
    loginSendCode: "Send",
    loginSendCodeSuccess: "Code sent successfully",
    loginSendCodeFailed: "Failed to send verification code",
    loginBeian: "京ICP备13007633号-2",
    loginBeianNumber: "京公网安备 11010802026375号",
    loginEmail: "Email",
    loginEmailPlaceholder: "Enter your email address",
    loginSubmit: "Submit",
    loginUsername: "Username",
    loginRegister: "Create Account",
    loginCompany: "Company",
    loginCompanyPlaceholder: "Enter your company name",
    loginPassword: "Password",
    loginRegisterPassword: "Enter your password",
    loginConfirmPassword: "Confirm Password",
    loginConfirmPasswordPlaceholder: "Confirm your password",
    loginRegisterPasswordPlaceholder: "Enter your password",
    loginRegisterConfirmPassword: "Confirm Password",
    loginRegisterConfirmPasswordPlaceholder:
      "Confirm your password",
    loginRegisterIndustry: "Industry",
    loginRegisterIndustryPlaceholder: "Select your industry",
    loginRegisterIndustryFailed:
      "Failed to load industry list. Please try again later.",
    loginRegisterPhone: "Phone Number",
    loginRegisterPhonePlaceholder: "Enter your phone number",
    loginRegisterSamePhoneFormat: "Enter a valid phone number",
    loginRegisterButton: "Register",
    loginRegisterSamePassword: "Passwords do not match",
    loginRegisterSamePasswordFailed: "Passwords do not match",
    loginRegisterSameAccount: "Account already exists",
    loginRegisterSameAccountFailed: "Account does not exist",
    loginRegisterSamePhone: "Phone number already exists",
    loginRegisterSamePhoneFailed: "Phone number does not exist",
    loginRegisterSameEmail: "Email already exists",
    loginRegisterSameEmailFailed: "Email does not exist",
    loginRegisterSameCode: "Invalid verification code",
    loginRegisterSameCodeFailed: "Verification code correct",
    loginRegisterSameAccountLength:
      "Account name must be 3–20 characters",
    loginUsernameFormat:
      "Username must be 3–20 letters, numbers, or underscores, or a valid email address",
    loginCompanyNameLength: "Company name must be 2–20 characters",
    loginRegisterSamePasswordLength:
      "Password must be 6–20 characters",
    loginPasswordComplexity:
      "Password must be 6–20 characters and contain at least 2 of: letters, numbers, and symbols",
    loginRegisterSamePasswordConfirm: "Passwords do not match",
    loginEmailFormatPlaceholder: "Enter a valid email address",
    loginSendCodeSuccess: "Code sent successfully. Please check your email.",
    loginSendCodeFailed:
      "Failed to send verification code. Please try again later.",
    loginVerifyCodeFailed: "Invalid verification code. Please check and try again.",
    loginRegisterSamePhoneLength: "Phone number must be 11 digits",
    loginRegisterAgreeTerms: "I have read and agree to",
    loginRegisterTerms: "Terms of Use",
    loginRegisterGVITerms: "GVI Service Agreement",
    forgotPassword: "Forgot Password",
    loginRegisterSameAccountTip: "Already have an account?",
    loginRegisterFailed: "Registration failed. Please try again later.",

    // Signup
    signup: {
      createAnAccount: "Sign up",
      fullName: "Account Name",
      enterFullName: "Please enter your account name",
      emailAddress: "Email Address",
      enterEmailAddress: "Please enter a valid email address",
      company: "Company",
      pLcompany: "Please enter your company name",
      password: "Password",
      confirmPassword: "Confirm Password",
      industry: "Industry",
      industryInput: "Please select at least one option",
      readAgree: "I have read and agree to",
      terms: "Terms of Service",
      GVI: "GVI Service Agreement",
      remember: "Please accept the terms",
      createAccount: "Create Account",
      haveAccount: "Already have an account?",
      successfullySentEmail:
        "Registration email sent successfully. Please check your inbox.",
      failedToSendEmail: "Failed to send registration email",
      status: {
        industryInput: "Please select at least one option",
        zcsucceeded: "Registration successful",
      },
      emailAlreadyInUse:
        "An account with this email address already exists",
      fullNameAlreadyInUse:
        "An account with this name already exists",
      goToDashboard: "Go to Dashboard",
      new_password: {
        login: "Log In",
      },
    },
    loginNewPassword: "New Password",
    loginNewPasswordPlaceholder: "Enter your new password",
    loginConfirmNewPassword: "Confirm New Password",
    loginConfirmNewPasswordPlaceholder: "Confirm your new password",
    loginResetSuccess: "Password reset successful. Please log in.",
    loginResetFailed: "Password reset failed. Please try again later.",

    // Forgot Password
    forgotPasswordTitle: "Forgot Password",
    email: "Email",
    pleaseEnterEmail: "Enter your email address",
    submit: "Submit",
    phoneNumber: "Phone Number",
    pleaseEnterPhoneNumber: "Enter your phone number",
    sendCode: "Send Code",
    resendCode: "Resend",
    sendCodeSuccess: "Verification code sent",
    newPassword: "New Password",
    pleaseEnterNewPassword: "Enter new password",
    confirmNewPassword: "Confirm Password",
    pleaseConfirmNewPassword: "Confirm password",
    passwordNotMatch: "Passwords do not match",
    emailSentSuccess: "Email sent successfully",
    backToLogin: "Back to Login",
    codeSentToEmail: "Reset link has been sent to your email",
    clickLinkInEmail:
      "Please click the link in the email to reset your password",
    resetSuccess: "Password reset successful",
    resetFailed: "Password reset failed",

    EnablePanoPoints: "Enable Panoramic Points",
    title: "Title",
    map: "Map",
    indexPage: "Home",
    log: "Log",
    data: "Data",
    list: "List",
    add: "Add",
    edit: "Edit",
    save: "Save",
    document: "Documentation",
    index: "Home",
    shareSettings: "Share Settings",
    Time: "Time",
    dateSettings: "Date Settings",
    passwordProtection: "Password Protection",
    saveSuccess: "Saved Successfully",
    saveFailed: "Save Failed",
    startPoint: "Start Point",
    targetPoint: "Target Point",
    update: "Update",
    delete: "Delete",
    edit: "Edit",
    rename: "Rename",
    share: "Share",
    download: "Download",
    detail: "Details",
    projectRename: "Rename",
    ok: "OK",
    userStatus: "Invalid User Status",
    close: "Close",
    open: "Open",
    open2: "On",
    close2: "Off",
    name: "Name",
    type: "Type",
    date: "Date",
    action: "Action",
    maintenance: "System Maintenance in Progress",
    version1: "For system performance and stability,",
    version2: "the system is undergoing planned maintenance and upgrades",
    maintenanceTime: "Maintenance Time",
    kindReminder: "Friendly Reminder",
    expectedImpact: "Expected Impact",
    maintenanceContent: "Maintenance Content",
    tis1: "1. Please arrange related work in advance and avoid operating during this period.",
    tis2: "2. After maintenance is completed, the system will automatically resume normal service. In case of special circumstances that result in extended maintenance time, we will notify you separately.",
    tis3: "3. After maintenance is completed, if there are any abnormalities, please contact [technical support email / customer service phone / feedback channel] in time.",
    tis4: "4. Thank you for your understanding and support! We will strive to minimize maintenance time and reduce the impact on you.",
    login: "Log In",
    startTime: "Start Time",
    endTime: "Expected Recovery Time",
    joystickPrompt: "Swipe to Control",
    joystickPrompt1: "Minimap",
    joystickPrompt2: "Return to Start",
    joystickPrompt3: "Options",
    joystickPrompt4: "Enable Collision",
    next: "Next",
    operation: "The system is being upgraded and maintained. Please wait.",
    view: "View",
    share: "Share Link",
    noData: "No panoramic data available",
    sceneNoDataTitle: "Notice",
    sceneNoPointCloudData: "No point cloud data is available for the current scene.",
    upload: "Upload",
    window: "Window",
    windowSelection: "Window Selection",
    vectorLayer: "Vector",
    panoramicLayer: "Panoramic",
    pointCloudLayer: "Point Cloud",
    model: "Model",
    gaussLayer: "3DGS",
    obliquePhotography: "3D Tiles",
    enterPassword: "Enter password",
    password: "Password",
    fieldName: "Field Name",
    fieldValue: "Field Value",
    home: "Home",
    cityJson: "CityJSON",
    allData: "All Data",
    measure: "Measure",
    manage: "Manage",
    panorama: "Panorama",
    photo: "Photo",
    setting: "Settings",
    setting2: "Options",
    collision: "Collision",
    visualAngle: "View Angle",
    pointCloud: "Point Cloud",
    annotation: "Annotation",
    label: "Label",
    clear: "Clear",
    layer: "Layer",
    cropping: "Crop",
    tianditu: "Tianditu",
    point: "Point",
    line: "Line",
    polygon: "Polygon",
    area: "Area",
    angle: "Angle",
    draw: "Draw",
    desc: "Remarks",
    color: "Color",
    size: "Size",
    device: "Device",
    tree: "Tree",
    custom: "Custom",
    startPoint: "Start Point",
    kilometer: "Kilometer",
    default: "Default",
    display: "Display",
    clip: "Clip",
    highLight: "Highlight",
    inner: "Inside",
    outer: "Outside",
    jump: "Jump",
    frames: "Frames",
    current: "Current",
    total: "Total",
    lastFrames: "Previous Frame",
    nextFrames: "Next Frame",
    yes: "Yes",
    no: "No",
    deleteConfirm: "Confirm Deletion",
    deleteCannotUndo: "This action cannot be undone",
    isDeleteData: "Delete Selected",
    checkAll: "Select All",
    pointSize: "Point Size",
    minSize: "Min Size",
    nameCannotRepeat: "Names cannot be duplicated",
    plzInputDesc: "Enter Remarks",
    attr: "Attribute",
    plzInputLayerName: "Enter Layer Name",
    createShareUrlFail: "Failed to create share link",
    tool: "Tool",
    detailMessage: "Details",
    search: "Search",
    ground: "Ground",
    airborne: "Airborne",
    effectiveTime: "Valid Until",
    day: "Day",
    reset: "Reset",
    inputTis: "Enter project name",
    successCreateShareUrl: "Share link created successfully.",
    effective: "Valid",
    copyUrl: "Copy Link",
    scanQrCode: "Scan QR Code",
    scanTheQrCodeWithABrowserToView: "Scan the QR code with a browser to view",
    plzEnterAnInteger: "Enter an integer",
    shareDayCannotLessThanOne: "Share duration must be at least 1 day",
    shareDayTis: "Share duration cannot exceed 14 days",
    copyShareUrlSuccess: "Link copied successfully",
    browerNotSupportAutoCopy: "Your browser does not support automatic copying",
    pickUpPanorama: "Select Panorama",
    panoramicSettings: "Panoramic Settings",
    trajectorySettings: "Trajectory Settings",
    playOptions: "Playback Options",
    measureTool: "Measurement Tool",
    clipTool: "Clip Tool",
    navigatation: "Navigation",
    uploadSuccess: "Upload Successful",
    uploadFailed: "Upload Failed",
    unupload: "Not Uploaded",
    uploadingtis: "Uploading",
    unviewAttr: "No Attributes",
    addLayer: "Add Layer",
    panoramapoint: "Panorama Point",
    editLayer: "Edit Layer",
    pointLayer: "Point Layer",
    lineLayer: "Line Layer",
    polygonLayer: "Polygon Layer",
    mapLabel: "Map Label",
    customLabel: "Custom Label",
    pickGpkg: "Select GPKG",
    pcSetting: "Point Cloud Settings",
    pcColor: "Background Color",
    shape: "Shape",
    pointType: "Point Type:",
    attribute: "Attribute",
    classification: "Classification",
    background: "Background",
    skybox: "Skybox",
    gradient: "Gradient",
    black: "Black",
    white: "White",
    scanBrowser: "Scan the QR code with a browser to view",
    scanQRCode: "Scan QR Code",
    createShareUrlSuccess: "Share link created successfully",
    previewProject: "Preview Project",
    opacity: "Opacity",
    strength: "Intensity",
    EDLradius: "Radius",
    enable: "EDL",
    control: "Control",
    currentViewControlModel: "Current View Control Mode",
    toolTipContent1:
      "Right-click to end single-point selection. Click the selection button to end point selection.",
    toolTipContent2:
      "Right-click to end single measurement. Click the measurement button to end measurement.",

    earth_controls: "Earth Controls",
    orbit_controls: "Orbit Controls",
    view_left: "Left",
    view_right: "Right",
    view_top: "Top",
    view_bottom: "Bottom",
    view_front: "Front",
    prompt: "Please check the layer data in Settings.",
    cutting: "Please select the cutting point",
    svcutting: "Saving crop result...",
    cropEffect: "Effect",
    not: "None",
    highlight: "Highlight",
    internal: "Inside",
    external: "Outside",
    BOXRange: "Bounding Box",
    long: "Length",
    wide: "Width",
    tall: "Height",
    XAxis: "Rotation around X-axis",
    YAxis: "Rotation around Y-axis",
    ZAxis: "Rotation around Z-axis",
    AxisX: "X-axis",
    AxisY: "Y-axis",
    AxisZ: "Z-axis",
    cuttingResult: "Result",
    view_back: "Back",
    view_focus: "Focus",
    cannotBeEmpty: "Cannot be empty",
    birthPointSetting: "Respawn Settings",
    UserOperationManual: "User Manual",
    userCenter: "User Center",
    Range: "Range",
    Gamma: "Gamma",
    Brightness: "Brightness",
    Contrast: "Contrast",
    cuttingOperation:
      "Please select the cutting point or click on the crop result to proceed",
    magnify: "Zoom In",
    about: "About",
    contact: "Contact Us",
    privacy: "Privacy Policy",
    terms: "Terms of Service",
    lessen: "Zoom Out",
    croppingMaxLimit: "You can create up to 8 crop boxes",
    selectBox: "Please select at least one box",
    enterLimitTime: "Enter valid duration",
    collisionOpen: "Collision detection enabled",
    collisionClose: "Collision detection disabled",
    shareCodeCannotLessThanSix: "Share code must be at least 6 digits",
    sharePasswordInvalid:
      "Share password must be 4–6 characters and contain only numbers or letters",
    RGB: "RGB",
    intensity: "Intensity",
    classification: "Classification",
    elevation: "Elevation",
    treeid: "Tree ID",
    returnNumber: "Return Number",
    numberOfReturns: "Number of Returns",
    colorMap: "Color Map:",

    deleteOK: "Deleted successfully",
    share2: "Sharing status cannot be modified",
    pageNotExist: "Sorry, the page you are looking for does not exist.",
    goBack: "Go Back",
    roam: "Roam",
    property: "Properties",
    plotting: "Plotting",
    croppingWarning: "This feature currently supports point cloud data only.",
    fixed: "Fixed",
    adaptive: "Adaptive Size",
    attenuated: "Attenuated",
    Square: "Square",
    Circle: "Circle",
    Paraboloid: "Paraboloid",
    Link: "Link",
    CopyUrl: "Copy Link",
    attributeMap: {
      0: "RGB",
      1: "File",
      3: "Elevation",
      4: "Intensity",
      8: "Classification",
      9: "Return Number",
      15: "Number of Returns",
      14: "Tree ID",
    },
    Current: "Current Frame",
    Step: "Step Size",
    JumpSpeed: "Jump Speed",
    LoopPlayback: "Loop Playback",
    FixedPerspective: "Fixed Perspective",
    attributeNames: [
      "Never Classified",
      "Unclassified",
      "Ground",
      "Low Vegetation",
      "Medium Vegetation",
      "High Vegetation",
      "Building",
      "Low Point",
      "Model Key Point",
      "Water",
      "Car",
      "Street Light",
      "Overlap",
      "Roof",
      "Wall",
      "Pole",
      "Powerline",
      "Tower",
      "Scissors Crossing Up",
      "Scissors Crossing Down",
      "Shield Wire",
      "Static Car",
      "Dynamic Car",
      "Trunk",
      "Branches and Leaves",
      "Billboard",
      "Guardrail",
      "Insulator",
      "Drain Wire",
      "Bridge",
      "Tunnel",
      "Ventilation Duct",
      "Cable",
      "Chandelier",
      "Electrical Box",
      "Attachment",
      "Sundries",
      "Noise Points",
      "Road",
      "Default",
      "Unclassified",
    ],
    All: "All",
    Share: "Share",
    loading: "Loading...",
    noData: "No more data",
    spaceExpand: "Expand Storage",
    logout: "Log Out",
    spaceExpands: "Expand Storage",
    spaceExpandCapacity: "Capacity (GB)",
    spaceExpandCapacityPlaceholder: "Enter expansion capacity (GB)",
    spaceExpandTime: "Duration (Months)",
    spaceExpandTimePlaceholder: "Enter expansion duration (months)",
    spaceExpandPoints: "Credits Consumed",
    spaceExpandError: "Please enter valid expansion parameters",
    spaceExpandSuccess: "Storage expanded successfully",

    personalCenter: "Profile",
    username: "Username",
    modify: "Edit",
    bind: "Link",
    nickname: "Nickname",
    nationality: "Nationality",
    industry: "Industry",
    modifyInfo: "Edit Profile",
    securityLevel: "Account Security Level",
    securityLevelWeak: "Weak",
    securityLevelMedium: "Medium",
    securityLevelHigh: "High",
    loginAccountPassword: "Login Password",
    loginAccountPasswordTip: "Login password ensures account security",
    bindEmail: "Link Email",
    bindEmailSuccess: "Linked",
    bindEmailFailed: "Not Linked",
    bindEmailTip:
      "Can be used for login, password recovery, and security verification",
    bindPhone: "Link Phone",
    bindPhoneSuccess: "Linked",
    bindPhoneFailed: "Not Linked",
    modifyEmail: "Change Email",
    modifyPhone: "Change Phone",
    modifyPassword: "Change Password",
    modifySuccess: "Updated successfully",

    modifyAvatar: "Change Avatar",
    avatar: "Avatar",

    unupload: "Waiting in queue.",
    uploading: "Data is being processed. Please wait.",
    fenxiang: "Share",

    shareLinkGenerated: "Share link has been generated",
    shareLinkTip: "You can share this link with others",
    linkExpireTime: "Link Expiration",

    privacy_info1: "GreenValley Privacy Policy",
    privacy_info2: "General Information",
    privacy_info3:
      "At GreenValley, we believe it is important for you to understand what types of information we collect and how we use it when you use our website and related applications and resources (collectively, the 'Service'). This Privacy Policy is designed to explain GreenValley's policies and procedures regarding the collection, use, and disclosure of information about you in connection with the Service. This Privacy Policy applies only to the Service.",
    privacy_info4:
      "By accessing the Service, you consent to the collection, use, and disclosure of your personal information as explained in this Privacy Policy. This Privacy Policy is incorporated into and is subject to the Terms of Service, which can be accessed here. Your use of the Service and any information you provide through the Service are subject to the terms of this Privacy Policy and our Terms of Service.",
    privacy_info5: "What You Will Find in This Privacy Policy",
    privacy_info6: "How We Collect Information About You",
    privacy_info7: "How We Use or Share Information About You",
    privacy_info8: "How We Safeguard Information About You",
    privacy_info9:
      "Other Matters Related to the Information We Collect About You",
    privacy_info10: "COLLECTION OF INFORMATION",
    privacy_info11:
      "We collect information about you in a variety of ways in connection with the Service.",
    privacy_info12:
      "REGISTRATION. To use some features and resources available through the Service, a user must complete our registration process. During registration, a user is required to provide certain categories of information, which may include personally identifiable information and other information about you, such as your name, address, email address, social network account information, password, user type, birthdate, gender, phone number, and how you heard about GreenValley.",
    privacy_info13:
      "OPTIONAL INFORMATION. At various other points during your use of the Service, you may have the option to provide additional information related to you. For example, you may wish to create a profile, post, comment on another user's post, or share a post with another person, or you may wish to utilize social network integrations or location-based features of the Service. For voluntary activities like these, you have the choice about whether to disclose the information necessary to use these features of the Service.",
    privacy_info14:
      "PASSIVE COLLECTION OF INFORMATION. In addition to the information that you actively provide to us by methods such as completing our registration process, commenting on, or sharing a post, we collect information about how you interact with the Service. We collect passive information for purposes such as testing and improving user experience with the Service and the compilation of demographic data and related usage information for internal purposes and for disclosure to third parties such as advertisers and business partners. The types of passive information we collect include, without limitation, certain standard information sent by your browser, such as your Internet Protocol (IP) address, your device ID, your browser type and capabilities and language, your operating system, the date and time you access the Service, and the referring website from which you linked to the Service. We also collect information related to your behavior within the Service (such as pages viewed, links clicked, and other actions taken within the Service). We also may utilize special links, electronic images, or other objects embedded within the Site—sometimes referred to as web beacons or tracking pixels—to collect information that helps determine and analyze how you and other visitors use the Site. If you have provided us with personal information through registration or other voluntary means, we may connect your personal information with passive information collected through our Site and use the combined information to help determine your potential interests in certain products, services, or information and for other purposes described in this Privacy Policy.",
    privacy_info15:
      "COOKIES. Information related to your interactions with the Service may be collected and stored by us in small data files—commonly referred to as cookies—that are placed onto your device by our servers. We may use temporary session cookies, which are terminated when you close your current session, to store certain personal information you provide for purposes of administering that session and facilitating transactions requested by you during that session. We also may use persistent cookies, which remain saved on your device after your current session is closed, to store information related to your interactions with the Service to facilitate future sessions. Most browsers automatically accept cookies, but you can usually modify your browser settings to decline cookies or to notify you when a cookie is being placed on your device. Each browser is different, but generally users can remove cookies by following directions provided in the browser's 'help' file. Please note that if you reject cookies or disable cookies, some features of the Service may not function properly.",
    privacy_info16:
      "COLLECTION OF INFORMATION FROM MINORS. The Service is intended for a general audience and is not intended for children under the age of 13. Use of the Service is prohibited for anyone under the age of 13. If you are between 13 and 18 years of age, you must secure authorization from your parents or legal guardian before using the Service. Although the Service may contain information that may be of interest to children, the Service is not directed at children, and we do not knowingly collect or solicit personal information from children under the age of 13.",
    privacy_info17: "USE AND SHARING OF INFORMATION",
    privacy_info18:
      "The Service enables users to post, access, and share user-generated content and other information across the GreenValley community, other social networks, and other websites and online services. It may include various features and functionality such as comments, message boards, or chat areas, where users can post information and communicate with one another. Please be aware that these posts and communications are being made publicly available online, and you do so at your own risk.",
    privacy_info19:
      "We will not knowingly use, share, or otherwise transfer information about you other than in accordance with the terms set forth in this Privacy Policy. Additionally, we may use, share, or otherwise transfer information about you for other purposes for which we have obtained your consent. Your consent may be implied, deemed (using an opt-out mechanism), or express. Express consent can be given orally, electronically, or in writing. Implied consent is consent that can reasonably be inferred from your action or inaction. Regardless of your decision regarding the sharing of your personal information, we may share demographic data and related usage information with our business partners in an aggregated or anonymized manner intended to remove or obscure any personal information that can identify any individual user.",
    privacy_info20:
      "We may use information about you in order to deliver products and services to you and to customize the Service to your interests and enhance your overall experience with the Service. We try to recognize you using various methods, including having you log in with your username and password. Once we recognize you, your experience may be customized for you so that you can see what interests you the most. In addition, as described above, we utilize passive information to learn more about how you interact with the Service. This passive information may be combined with other information and used for purposes such as enhancing your experience using the Service, improving the Service, testing and enhancing security, and compilation of demographic data and related usage information for our internal purposes and for other purposes described in this Privacy Policy.",
    privacy_info21:
      "While we strive to protect the personal information of our users, we may use, share, or otherwise transfer your personal information without your knowledge or consent if required by applicable law or regulatory requirements or in the good-faith belief that such action is necessary or appropriate.",
    privacy_info22:
      "From time to time, we may decide that it is more efficient to use third parties to perform specific functions related to the Service. If we use a third party to perform specific functions (such as sending communications to our users on our behalf), then information (such as contact information) may be shared with that third party to the extent necessary for that third party to perform that function. We authorize these third-party service providers to use personally identifiable information only for the purpose of providing the specific services requested by us. Third-party service providers covered by this paragraph do not include third-party sites, applications, or services that are accessed via links within the Service, which are governed by a more specific provision below.",
    privacy_info23:
      "If you opt in to a feature that allows third parties to contact you, personal information about you (such as your contact information and other information collected during your visit to the Service) may be shared with data aggregators, marketers, and other organizations (possibly in the form of list rental).",
    privacy_info24:
      "In the event that we sell, assign, or transfer some or all of our business to a successor or acquirer, we may sell, assign, or transfer all of your information, regardless of your status, to such successor or acquirer.",
    privacy_info25: "SECURITY",
    privacy_info26:
      "We have security measures in place to help protect against the unauthorized access of personally identifiable information under our control. We utilize both online and offline security methods, including firewalls, passwords, and restricted physical access to the places where your information is stored to help protect personally identifiable information. Our staff is trained to comply with our security procedures, and our security procedures are regularly reviewed and revised as we deem necessary.",
    privacy_info27: "HOW YOU CAN ACCESS AND UPDATE YOUR INFORMATION",
    privacy_info28:
      "Our goal is for any personal information in our possession to be as accurate, current, and complete as necessary for the purposes for which we use that information. If you want to review, verify, or correct your personal information, please contact us using the contact information set out below. We reserve the right not to change any personal information and instead append any alternative information the individual concerned believes is appropriate. To some extent, we rely on individuals to update their own personal information. Unless an individual advises us of these important changes, we may have no way of knowing about them.",
    privacy_info29: "ELECTRONIC MAILING LISTS AND HOW TO UNSUBSCRIBE",
    privacy_info30:
      "We may use your contact information periodically in order to send you email or other communications regarding updates to the Service and to alert you or remind you of happenings related to the Service. The frequency of these messages will vary depending upon various factors.",
    privacy_info31:
      "If you no longer wish to receive emails from us and want to be removed from our electronic mailing list, please",
    privacy_info32: "contact us",
    privacy_info33:
      "and include 'Email Unsubscribe' in the body of your message. If you choose to unsubscribe from our mailing lists, we will hold your contact information on file marked so that we do not inadvertently contact you if your details are subsequently provided to us by a third party.",
    privacy_info34: "OTHER PROVISIONS",
    privacy_info35:
      "Your use of the Service indicates an acceptance of the terms of the Privacy Policy. We reserve the right to update or amend this Privacy Policy at any time. We will post any revised version of this Privacy Policy on our website, and we encourage you to refer back to it on a regular basis. The changes contained in any such revised version of this Privacy Policy will be effective from the time such revised version is posted unless otherwise specifically stated therein.",
    privacy_info36:
      "This Privacy Policy does not create or confer upon any individual any rights, or impose upon GreenValley any rights or obligations outside of, or in addition to, any rights or obligations imposed by the privacy laws of such individual's jurisdiction, as applicable. Privacy legislation or an individual's right to privacy may differ from one jurisdiction to another. The rights and obligations described in this Privacy Policy may not apply to all individuals or in all jurisdictions. Should there be, in a specific case, any inconsistency between this Privacy Policy and the applicable privacy laws of such individual's jurisdiction, this Privacy Policy shall be interpreted, in respect of that case, to give effect to, and comply with, such privacy laws.",
    privacy_info37:
      "This Privacy Policy applies solely to the information collected by us online through the Service and does not apply to any website, application, or service other than the Service. The Service contains links to other websites, applications, and services provided by third parties that we do not own or control, and we are not responsible for the privacy policies and practices of those third parties. Similarly, we are not responsible for the privacy policies and practices of any other websites, applications, and services from which you linked to our Service. We encourage you to be aware when you leave our Service and to read the privacy policies of each and every third party that may be providing websites, applications, or information linked to the Service.",
    privacy_info38:
      "This Privacy Policy may include examples but is not intended to be restricted in its application to such examples; thus, 'including' means 'including without limitation.'",
    privacy_info39:
      "Your privacy is important to us. If you have any questions about any of the provisions described above, please",
    privacy_info40: "Last Updated: 2019-01-24",

    recharge: "Recharge",
    rechargeCardNumber: "Enter your recharge card number",
    rechargeCardUsed: "Recharge card has already been used",

    "edit-phoneNewPhone": "New Phone Number",
    "edit-phoneCurrentPhone": "Current Phone Number",
    "edit-phoneConfirmPhone": "Confirm Phone Number",
    "edit-phoneConfirmPhoneDesc": "Verify Current Phone",
    "edit-phoneConfirmSuccess": "Updated successfully",
    "edit-phoneBindNewPhone": "Link New Phone",
    "edit-phoneEnterConfirmPhone":
      "The two phone numbers entered do not match.",
    "edit-phoneSave": "Save",
    "edit-phoneChangeSuccess": "Phone number verified successfully.",
    "edit-phoneCodeError": "Invalid verification code.",
    "edit-emailCurrentEmail": "Current Email Address",
    "edit-emailNewEmail": "New Email Address",
    "edit-emailConfirmEmail": "Verify Current Email",
    "edit-emailTitle": "Change Email Address",
    "edit-emailConfirmSuccess": "Updated successfully",
  },
  accountSetting: {
    title: "Account Settings",
    nicknameLabel: "Username",
    avatarLabel: "Avatar",
    newPasswordLabel: "New Password",
    confirmNewPasswordLabel: "Confirm New Password",
    emailLabel: "Email",
    emailSupportHint: "Please contact GreenValley support to change your email.",
    companyLabel: "Company",
    industryLabel: "Industry",
    avatarImageOnly: "Please upload an image file",
    avatarTooLarge: "Avatar file size cannot exceed 5 MB",
    loadFailed: "Failed to load account information",
    uploadSuccess: "Avatar uploaded successfully",
    uploadFailed: "Failed to upload avatar",
    updateSuccess: "Account updated successfully",
    updateFailed: "Failed to update account",
    industryOptions: {
      surveyingMapping: "Surveying and Mapping",
      forestryEcology: "Forestry and Ecology",
      smartCity: "Smart City"
    },
    rules: {
      nicknameRequired: "Please enter a username",
      nicknameInvalid: "Username must be 3–20 letters, numbers, or underscores, or a valid email address",
      avatarRequired: "Please upload an avatar",
      emailRequired: "Please enter an email address",
      emailInvalid: "Please enter a valid email address",
      newPasswordRequired: "Please enter a new password",
      newPasswordInvalid:
        "Password must be 6–20 characters and include at least two of: letters, numbers, and symbols",
      confirmNewPasswordRequired: "Please confirm your new password",
      confirmNewPasswordMismatch: "New password and confirmation do not match"
    }
  },
  userManage: {
    pageTitle: "User Management",
    backHome: "Back to Home",
    newUser: "New User",
    loading: "Loading...",
    username: "Username",
    usernameSearchPlaceholder: "Search by username",
    email: "Email",
    effective: "Status",
    lastLogin: "Last Login",
    operation: "Operation",
    normal: "Active",
    disabled: "Disabled",
    view: "View",
    edit: "Edit",
    delete: "Delete",
    previous: "Previous Page",
    next: "Next Page",
    noData: "No user data",
    deleteConfirmTitle: "Are you sure you want to delete user \"{name}\"?",
    loadListFailed: "Failed to load user list",
    createSuccess: "User created successfully",
    createFailed: "Failed to create user",
    updateSuccess: "User updated successfully",
    updateFailed: "Failed to update user",
    deleteSuccess: "User deleted successfully",
    deleteFailed: "Failed to delete user",
    modal: {
      createTitle: "Create User",
      editTitle: "Edit User",
      viewTitle: "View User",
      usernameLabel: "Username",
      usernamePlaceholder: "Enter username",
      emailLabel: "Email",
      emailPlaceholder: "Enter email",
      effectiveLabel: "Status",
      emailAction: "Email Action",
      rules: {
        usernameRequired: "Please enter a username",
        usernameInvalid:
          "Username must be 3–20 letters, numbers, or underscores, or a valid email address",
        emailRequired: "Please enter an email address",
        emailInvalid: "Please enter a valid email address",
        effectiveRequired: "Please select a user status"
      }
    }
  },
  threeD: {
    layers: "Layers",
    filterByNameAndTags: "Filter by name and tags...",
    pointCloudLayers: "Point Cloud Layers",
    panoramicLayers: "Panoramic Layers",
    vectorLayers: "Vector Layers",
    annotationLayers: "Annotation Layers",
    modelLayers: "Model Layers",
    gaussLayers: "3DGS Layers",
    obliquePhotographyLayers: "3D Tiles Layers",
    visibility: "Visibility",
    rename: "Rename",
    editStyle: "Edit Style...",
    zoomToLayer: "Zoom to Layer",
    exportData: "Export Data...",
    delete: "Delete",
    attributeTable: "Attribute Table",
    twoDView: "2D View",
    threeDView: "3D View",
    resetView: "Reset View",
    zoomToFullExtent: "Zoom to Full Extent",
    pointAnnotation: "Point Annotation",
    lineAnnotation: "Line Annotation",
    polygonAnnotation: "Polygon Annotation",
    measureDistance: "Measure Distance",
    measureArea: "Measure Area",
    measureVolume: "Measure Volume",
    profileAnalysis: "Profile Analysis",
    modelClipping: "Model Clipping",
    swipeComparison: "Swipe Comparison",
    shareView: "Share View",
    exportReport: "Export Report",
    createBookmark: "Create Bookmark",
    screenshot: "Screenshot",
    settings: "Settings",
    profileAnalysis: "Profile Analysis",
    drawLineOnMapToGenerateProfile: "Draw a line on the map to generate a profile",
    clippingTool: "Clipping Tool",
    drawAPolygonToDefineClippingArea: "Draw a polygon to define the clipping area",
    keepInside: "Keep Inside",
    keepOutside: "Keep Outside",
    clearClipping: "Clear Clipping",
    shareThisView: "Share This View",
    shareableLink: "Shareable Link",
    setPasswordOptional: "Set Password (Optional)",
    linkExpiresIn: "Link Expires In",
    expirationDate: "Expiration Date",
    days: "days",
    generateQRCode: "Generate QR Code",
    plotting: "Plotting Model",
    profile: "Profile",
    cModels: "Cut Model",
    sourceLayers: "Source Layers",
    profileTool: {
      defaultName: "Profile {count}",
      startPoint: "Start Point",
      endPoint: "End Point",
      operationPreview: "Operation Preview"
    },
    timeUnit: {
      year: "Year",
      month: "Month",
      day: "Day",
      hour: "Hour"
    },
    untitledProject: "Untitled Project",
    recipientsCanViewButCannotEdit: "Recipients can view the current scene but cannot edit it.",
    distance: "Distance",
    area: "Area",
    volume: "Volume",
    bookmarkSaved: "Bookmark saved",
    screenshotSaved: "Screenshot saved to Downloads",
    screenshotFailed: "Screenshot failed",
    modeSwitch: {
      switchTo2D: "Switch to 2D Mode",
      switchTo3D: "Switch to 3D Mode",
      zoomIn: "Zoom In",
      zoomOut: "Zoom Out",
      resetView: "Reset View",
      roam: "Roam",
      pointTool: "Point Tool",
      lineTool: "Line Tool",
      polygonTool: "Polygon Tool",
      circleTool: "Circle Tool",
      volumeTool: "Volume Tool",
      profileTool: "Profile Tool",
      cutModelTool: "Cut Model Tool"
    },
    // UI组件相关
    systemSettings: {
      title: "System Settings",
      backgroundColor: "Background Color",
      spawnPointSettings: "Spawn Point Settings",
      setSpawnPoint: "Set Spawn Point",
      skybox: "Skybox",
      light: "Light",
      black: "Black",
      white: "White",
      iconAlt: "Settings Icon"
    },
    bookmark: {
      title: "Bookmark",
      name: "Name",
      namePlaceholder: "Enter bookmark name",
      description: "Description",
      descriptionPlaceholder: "Enter description",
      save: "Save",
      cancel: "Cancel",
      edit: "Edit",
      delete: "Delete",
      loadFailed: "Failed to load bookmarks",
      saveSuccess: "Bookmark saved successfully",
      saveFailed: "Failed to save bookmark",
      loading: "Loading...",
      noBookmarks: "No bookmarks available",
      only3DSaveWarning: "Bookmarks can only be saved in 3D view",
      viewNotReadyWarning: "Current view is not ready. Unable to save bookmark.",
      only3DApplyWarning: "Bookmarks can only be applied in 3D view",
      appliedSuccess: "Bookmark view applied",
      nameMinLength: "Name must be at least 2 characters",
      nameMaxLength: "Name cannot exceed 20 characters"
    },
    polygonDetails: {
      lineWidth: "Line Width",
      color: "Color",
      opacity: "Opacity",
      length2d: "2D Length",
      length3d: "3D Length",
      area2d: "2D Area",
      area3d: "3D Area",
      perimeter2d: "2D Perimeter",
      perimeter3d: "3D Perimeter",
      minElevation: "Minimum Elevation",
      maxElevation: "Maximum Elevation",
      elevationDiff: "Elevation Difference",
      borderColor: "Border Color",
      fillColor: "Fill Color",
      slope: "Slope Angle",
    },
    profileDetails: {
      thickness: "Thickness",
      colorMode: "Color Mode",
      none: "None",
      customColor: "Custom Color",
    },
    layerTree: {
      filterPlaceholder: "Filter by name and tag...",
      layers: "Layers",
      detail: "Details",
      delete: "Delete",
      pointCloudLayers: "Point Cloud Layers",
      trajectory: "Trajectory",
      vectorLayers: "Vector Layers",
      newPlotLayer: "New Plot Layer",
      deletePrompt: "Are you sure you want to delete {name}?",
    },
    shareSettings: {
      title: "Share Settings",
      shareLink: "Share Link",
      encryption: "Encryption",
      browserNotSupport: "Your browser does not support clipboard functionality",
      copySuccess: "Link copied successfully",
      copyFailed: "Failed to copy link",
      preview3D: "3D preview feature, can be extended based on green-3d",
      generatingQRCode: "Generating QR code...",
      hours24: "24 Hours",
      days7: "7 Days",
      days14: "14 Days",
      customize: "Customize",
      hour: "Hour",
      day: "Day",
      week: "Week",
      month: "Month",
      preview3D: "3D Preview",
      application: "Apply",
      qrCode: "QR Code",
      scanQRCode: "Scan QR Code",
      copy: "Copy",
      advanced: "Advanced",
      validityPeriod: "Validity Period",
      generatingQRCode: "Generating QR code...",
      scanQRCode: "Scan QR Code",
    },
    bottomToolbar: {
      share: "Share",
      export: "Export",
      compare: "Compare",
      bookmark: "Bookmark",
      exportConfig: "Screenshot",
      importConfig: "Import Config",
      exportPdfSuccess: "Report exported successfully",
      exportPdfFailed: "Report export failed",
      exportPdfNoTask: "Please select a task first",
    },
    pointCloudCompare: {
      title: "Period Compare",
      unavailableTitle: "Period compare is unavailable",
      missingProjectId: "Project ID is missing.",
      insufficientTasks: "This project needs at least two tasks.",
      syncCamera: "Sync View",
      close: "Close",
      leftPeriod: "Left Period",
      rightPeriod: "Right Period",
    },
    share: {
      title: "Share",
      shareLink: "Share Link",
      encryption: "Encryption",
      copy: "Copy",
      preview3D: "3D Preview",
      advanced: "Advanced",
      validityPeriod: "Validity Period",
      hours24: "24 Hours",
      days7: "7 Days",
      days14: "14 Days",
      customize: "Customize",
      hour: "Hour",
      day: "Day",
      week: "Week",
      month: "Month",
      application: "Apply",
      qrCode: "QR Code",
      scanQRCode: "Scan QR Code",
      copySuccess: "Link copied successfully",
      copyFailed: "Failed to copy link",
      browserNotSupport: "Your browser does not support clipboard",
      previewMessage: "3D preview feature, can be extended based on green-3d",
      generatingQRCode: "Generating QR code..."
    },
    cutModel: {
      cropEffect: "Crop Effect",
      boxInfo: "Crop Info",
      highlight: "Highlight",
      internal: "Inside",
      external: "Outside",
      position: "Position",
      scale: "Size",
      rotation: "Rotation",
      long: "Length",
      wide: "Width",
      tall: "Height",
      x: "X",
      y: "Y",
      z: "Z",
      defaultName: "Cut {count}",
      maxLimitReached: "Maximum cut limit (8) reached. Please delete existing cuts first.",
      boundsUnavailable: "Point cloud bounds are unavailable. Please wait until the point cloud finishes loading.",
    },
    lineDetails: {
      lineWidth: "Line Width",
      color: "Color",
      opacity: "Opacity",
      length2d: "2D Length",
      length3d: "3D Length",
      minElevation: "Minimum Elevation",
      maxElevation: "Maximum Elevation",
      elevationDiff: "Elevation Difference",
      minSlope: "Minimum Slope",
      maxSlope: "Maximum Slope",
    },
    pointCloud: {
      metadata: "Metadata",
      pointCount: "Point Count",
      boundingBox: "Bounding Box",
      renderSetting: "Render Settings",
      pointSize: "Point Size",
      pointMode: "Point Mode",
      pointShape: "Point Shape",
      attribute: "Attribute",
      heightRange: "Height Range",
      colorRamp: "Color Ramp",
      edl: "EDL (Eye Dome Lighting)",
      borderWidth: "Border Width",
      borderColor: "Border Color",
      Easting: "Easting",
      rgb: "RGB",
      elevation: "Elevation",
      intensity: "Intensity",
      classification: "Classification",
      returnNumber: "Return Number",
      pointSourceId: "Point Source ID",
      circle: "Circle",
      square: "Square",
      paraboloid: "Paraboloid",
      rainbow: "Rainbow",
      viridis: "Viridis",
      plasma: "Plasma",
      inferno: "Inferno",
      magma: "Magma",
      grayscale: "Grayscale",
      min: "Min",
      max: "Max",
      type: "Type",
      size: "Size",
      color: "Color",
      attribute: "Attribute",
      opacity: "Opacity",
      imageTag: "Image Tag",
      select: "Select",
      iconEmptyTip: "No icons yet. Click the upload button above to add one.",
      iconDeleteSuccess: "Icon deleted successfully",
      Easting: "Easting",
      Northing: "Northing",
      Z: "Z",
      coordinatesWgs84: "WGS84 Coordinates",
      numberOfReturns: "Number of Returns Colors",
    },

  }
};
